<template>
  <div style="padding:0 100px;">
    <h3 style=" text-align: center;">{{ data2.title }}</h3>
    <p class="info" style="padding:0 50px">
      <span>行业制度</span>
      <span>{{ data2.accessNum }} 阅读</span>
      <span>{{ data2.downloadNum }} 下载</span>
      <span>{{ data2.userName }}</span>
      <span>{{ data2.createTime }} 发布</span>
      <el-button
        size="mini"
        type="primary"
        @click="download()"
        v-if="data2.downloadFlag === 1 && permissionList.download"
      >
        文件下载
      </el-button>
    </p>
    <p style="padding:0 50px">
      {{ data2.content }}
    </p>
    <iframe :src="fileViewUrl" style="width: 100%; height: calc( 100vh - 250px )" allow="fullscreen" border="none"></iframe>
  </div>
</template>

<script>
import {
  getKnowledgeGroupSelectById,
  viewKnowledgeGroup,
  groupDownload,
} from '@/api/crmedical/knowledge/group';
import urlSettings from '@/config/url-settings';
import { Base64 } from 'js-base64';
import { mapGetters } from 'vuex';

export default {
  props: ['data'],
  data() {
    return {
      data2: {},
      fileViewUrl: '',
    };
  },
  created() {
    getKnowledgeGroupSelectById({ id: this.data.id }).then((res) => {
      res.data.accessNum = res.data.accessNum == null ? 0 : res.data.accessNum;
      res.data.downloadNum = res.data.downloadNum == null ? 0 : res.data.downloadNum;
      this.data2 = res.data;
      if (this.data2.link) {
        this.fileViewUrl =
          urlSettings.FILE_VIEW_URL + encodeURIComponent(Base64.encode(this.data2.link));
      }
    });

    let fd = new FormData();
    fd.append('id', this.data.id);
    viewKnowledgeGroup(fd).then((res) => {
      console.log('res viewKnowledgeGroup==>', res);
    });
  },
  //'knowledgeprojectfile_dowanload', 
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        download: this.vaildData(this.permission.knowledgegroupfile_download, false),
      };
    },
  },
  methods: {
    download() {
      let link = this.data2.link;
      if (!link) return;
      if (link.search('https') == -1) {
        link = link.replace('http', 'https');
      }
      console.log('link==>', link);
      let a = document.createElement('a'); // 创建隐藏的可下载链接
      a.download = link;
      a.style.display = 'none';
      a.href = link;
      document.body.appendChild(a);
      a.click(); // 触发点击
      document.body.removeChild(a);
          let fd = new FormData();
    fd.append('id', this.data.id);
      groupDownload(fd).then((res) => {
        console.log('res groupDownload ==>', res);
      });
    },
  },
};
</script>

<style scoped>
.info {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>